"use strict";
// export type LocaleType = "pl" | "en" | "fr" | "de" | "it" | "he";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleType = void 0;
var LocaleType;
(function (LocaleType) {
    LocaleType["en"] = "en";
    LocaleType["pl"] = "pl";
    LocaleType["fr"] = "fr";
    LocaleType["de"] = "de";
    LocaleType["it"] = "it";
    LocaleType["he"] = "he";
    LocaleType["es"] = "es";
    LocaleType["bg"] = "bg";
    LocaleType["pt"] = "pt";
    LocaleType["ro"] = "ro";
})(LocaleType = exports.LocaleType || (exports.LocaleType = {}));
//# sourceMappingURL=Locale.types.js.map